import { render, staticRenderFns } from "./ExamBrowser.vue?vue&type=template&id=22abfb30&scoped=true&"
import script from "./ExamBrowser.vue?vue&type=script&lang=js&"
export * from "./ExamBrowser.vue?vue&type=script&lang=js&"
import style0 from "./ExamBrowser.vue?vue&type=style&index=0&id=22abfb30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22abfb30",
  null
  
)

export default component.exports